export enum Colors {
   BLACK = '#000',
   WHITE = '#fff',
   DARK_GRAY = '#333',
   LIGHT_GRAY = '#D3D3D3',
   NAVY_BLUE = '#000080',
   RGBA_NAVY_BLUE = 'rgba(0, 0, 128, 0.1)',
   NAVY_GREEN = '#2F4F4F',
   RGBA_TRANSPARENT_BLACK = 'rgba(0, 0, 0, 0.2)',
}
